import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

type PageWidth = 'narrow' | 'standard' | 'wide' | 'full';

const MAX_WIDTH: Record<PageWidth, number | 'none'> = {
  narrow: 800,
  standard: 1200,
  wide: 1440,
  full: 'none',
};

interface PageContainerProps {
  /**
   * standard (1200px) for normal pages, narrow (800px) for forms and
   * single-column settings, wide (1440px) for dense lists, full for the
   * studio and workspace screens.
   */
  width?: PageWidth;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * The one page frame: the same side gutters and top spacing everywhere, so
 * content doesn't jump width or position between pages.
 */
const PageContainer: React.FC<PageContainerProps> = ({ width = 'standard', children, sx }) => (
  <Box
    component="main"
    sx={[
      {
        width: '100%',
        maxWidth: MAX_WIDTH[width],
        mx: 'auto',
        px: { xs: 2, sm: 3 },
        pt: { xs: 3, md: 4 },
        pb: { xs: 6, md: 8 },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
);

export default PageContainer;
